module.exports = __webpack_public_path__ + "static/media/DSC00206.657bb572.jpg";